import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import PainPoints from './components/PainPoints';
import Recommendation from './components/Recommendation';
import Pricing from './components/Pricing';
import Experience from './components/Experience';
import Compliance from './components/Compliance';
import BottomCTA from './components/BottomCTA';
import Footer from './components/Footer';
import ConsultationDrawer from './components/ConsultationDrawer';
import ExampleModal from './components/ExampleModal';

export default function Home() {
  useEffect(() => {
    // Show overlay when drawer opens
    const drawer = document.getElementById('consultation-drawer');
    const overlay = document.getElementById('consultation-overlay');
    
    const observer = new MutationObserver(() => {
      if (drawer && overlay) {
        if (drawer.classList.contains('translate-x-full')) {
          overlay.classList.add('hidden');
        } else {
          overlay.classList.remove('hidden');
        }
      }
    });

    if (drawer) {
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <SocialProof />
      <PainPoints />
      <Recommendation />
      <Pricing />
      <Experience />
      <Compliance />
      <BottomCTA />
      <Footer />
      <ConsultationDrawer />
      <ExampleModal />
    </div>
  );
}